export const carpayPaymentMethodRoute = (orderId = ':order_id') => `/orders/carpay/${orderId}/payment-method`
